import axios from "@common/api/desktop/axios";
import buildTree from "@helpers/buildTree";
import prepareDetails, { normalizeStatusCode } from "@helpers/prepareDetails";

export const mapToSelect = (data, alternative = false) => {
  // transactions tickets filterlist response is slightly different
  return data.map((row) => {
    return alternative
      ? { value: row.key, text: row.text, key: row.key }
      : { key: row.id, value: row.id, text: row.name };
  });
};

export const getOwnershipProfiles = async (operatorId) => {
  const response = await axios.get(
    `OwnershipProfile/Profiles?operatorId=${operatorId}`,
  );
  return mapToSelect([{ name: "All", id: -1 }, ...response.data]);
};

export const getManufacturers = async (operatorId) => {
  const response = await axios.get(`Organisation/manufacturers/${operatorId}`);
  return mapToSelect(response.data);
};

export const getManufacturersRaw = async (operatorId) => {
  const response = await axios.get(
    `Organisation/Manufacturer/Raw/${operatorId}`,
  );
  return response.data;
};

export const getNoteAcceptorModels = async (operatorId) => {
  const response = await axios.get(
    `Organisation/noteacceptormodels/${operatorId}`,
  );
  return mapToSelect(response.data);
};

export const getNoteAcceptorModelsRaw = async (operatorId) => {
  const response = await axios.get(
    `Organisation/NoteAcceptor/Raw/${operatorId}`,
  );
  return response.data;
};

export const getSuppliers = async (operatorId) => {
  const response = await axios.get(`Organisation/suppliers/${operatorId}`);
  return mapToSelect(response.data);
};

export const getSuppliersRaw = async (operatorId) => {
  const response = await axios.get(
    `Organisation/Supplier/Raw/${operatorId}`,
  );
  return response.data;
};

export const getDepots = async (operatorId) => {
  const response = await axios.get(`Organisation/depots/${operatorId}`);
  return mapToSelect(response.data);
};

export const getDepotsRaw = async (operatorId) => {
  const response = await axios.get(
    `Organisation/Depot/Raw/${operatorId}`,
  );
  return response.data;
};

export const getCategories = async (operatorId) => {
  const response = await axios.get(`Organisation/categories/${operatorId}`);
  return mapToSelect(response.data);
};

export const getCategoriesRaw = async (operatorId) => {
  const response = await axios.get(
    `Organisation/Category/Raw/${operatorId}`,
  );
  return response.data;
};

export const getGameTitles = async (operatorId) => {
  const response = await axios.get(`Organisation/gametitles/${operatorId}`);
  return mapToSelect(response.data);
};

export const getGameTitlesRaw = async (operatorId) => {
  const response = await axios.get(
    `Organisation/GameTitle/Raw/${operatorId}`,
  );
  return response.data;
};

export const getGameTitleLibraryRaw = async (operatorId) => {
  const response = await axios.get(
    `Organisation/GameTitleLibrary/Raw/${operatorId}`,
  );
  return response.data;
};

export const getStatuses = async () => {
  const response = await axios.get(`Asset/option/statuswithqty`);
  return response.data;
};

export const getCabinetTypes = async (operatorId) => {
  const response = await axios.get(`Organisation/cabinettypes/${operatorId}`);
  return mapToSelect(response.data);
};

export const getCabinetTypesRaw = async (operatorId) => {
  const response = await axios.get(
    `Organisation/CabinetType/Raw/${operatorId}`,
  );
  return response.data;
};

export const getVariants = async () => {
  const response = await axios.get(`Organisation/variants`);
  return mapToSelect(response.data);
};

export const getGroupings = async (operatorId) => {
  const response = await axios.get(`Asset/option/groupby/${operatorId}`);
  return mapToSelect(response.data);
};

export const deleteAsset = async (assetId) => {
  const response = await axios.put(`Asset/delete/${assetId}`);
  return response.data;
};

export const getAssets = async (
  OperatorId,
  MachineTypeId,
  ManufacturerId,
  CabinetTypeId,
  GameId,
  NoteAcceptorId,
  StatusCode,
  VariantId,
  GroupBy,
  searchText,
  Depot,
  ownershipProfileId,
  SupplierId,
  showSummary,
) => {
  const Search = searchText || "#";

  const body = {
    OperatorId,
    MachineTypeId,
    ManufacturerId,
    CabinetTypeId,
    GameId,
    NoteAcceptorId,
    StatusCode: normalizeStatusCode(StatusCode),
    VariantId,
    GroupBy,
    Search,
    Depot,
    ownershipProfileId,
    SupplierId,
    showSummary,
  };

  const response = await axios.put(`Asset/tree/`, body);
  return {
    statuses: response.data.statuses,
    assets: buildTree(response.data.treeInfo),
  };
};

export const getAssetTable = async (
  OperatorId,
  MachineTypeId,
  ManufacturerId,
  CabinetTypeId,
  GameId,
  NoteAcceptorId,
  StatusCode,
  VariantId,
  GroupBy,
  searchText,
  Depot,
  ownershipProfileId,
  SupplierId,
  showSummary,
) => {
  const Search = searchText || "#";

  const body = {
    OperatorId,
    MachineTypeId,
    ManufacturerId,
    CabinetTypeId,
    GameId,
    NoteAcceptorId,
    StatusCode: normalizeStatusCode(StatusCode),
    VariantId,
    GroupBy,
    Search,
    Depot,
    ownershipProfileId,
    SupplierId,
    showSummary,
  };

  const response = await axios.put(`Asset/AssetTable`, body);
  return response.data;
};

export const getAssetGameLibrary = async (
  OperatorId,
  MachineTypeId,
  ManufacturerId,
  CabinetTypeId,
  GameId,
  NoteAcceptorId,
  StatusCode,
  VariantId,
  GroupBy,
  searchText,
  Depot,
  ownershipProfileId,
  SupplierId,
  showSummary,
) => {
  const Search = searchText || "#";

  const body = {
    OperatorId,
    MachineTypeId,
    ManufacturerId,
    CabinetTypeId,
    GameId,
    NoteAcceptorId,
    StatusCode: normalizeStatusCode(StatusCode),
    VariantId,
    GroupBy,
    Search,
    Depot,
    ownershipProfileId,
    SupplierId,
    showSummary,
  };

  const response = await axios.put(`Asset/AssetTable/Details/GameLibrary`, body);
  return response.data;
};

export const getAssetsDownload = async (
  OperatorId,
  MachineTypeId,
  ManufacturerId,
  CabinetTypeId,
  GameId,
  NoteAcceptorId,
  StatusCode,
  VariantId,
  GroupBy,
  searchText,
  Depot,
  ownershipProfileId,
  SupplierId,
  showSummary,
) => {
  const Search = searchText || "#";

  const body = {
    OperatorId,
    MachineTypeId,
    ManufacturerId,
    CabinetTypeId,
    GameId,
    NoteAcceptorId,
    StatusCode: normalizeStatusCode(StatusCode),
    VariantId,
    GroupBy,
    Search,
    Depot,
    ownershipProfileId,
    SupplierId,
    showSummary,
  };

  const response = await axios.put(`Asset/tree/export`, body, {
    responseType: "arraybuffer",
  });
  return response;
};

export const getAssetsDetailsDownload = async (
  OperatorId,
  MachineTypeId,
  ManufacturerId,
  CabinetTypeId,
  GameId,
  NoteAcceptorId,
  StatusCode,
  VariantId,
  GroupBy,
  searchText,
  Depot,
  ownershipProfileId,
  SupplierId,
  showSummary,
) => {
  const Search = searchText || "#";

  const body = {
    OperatorId,
    MachineTypeId,
    ManufacturerId,
    CabinetTypeId,
    GameId,
    NoteAcceptorId,
    StatusCode: normalizeStatusCode(StatusCode),
    VariantId,
    GroupBy,
    Search,
    Depot,
    ownershipProfileId,
    SupplierId,
    showSummary,
  };

  const response = await axios.put(`Asset/AssetTableDetails/Export`, body, {
    responseType: "arraybuffer",
  });
  return response;
};

export const categoryDownload = async (operatorId) => {
  const response = await axios.get(`Organisation/Category/Export/${operatorId}`, {
    responseType: "arraybuffer",
  });
  return response;
};

export const manufacturerDownload = async (operatorId) => {
  const response = await axios.get(
    `Organisation/Manufacturer/Export/${operatorId}`,
    {
      responseType: "arraybuffer",
    },
  );
  return response;
};

export const cabinetTypeDownload = async (operatorId) => {
  const response = await axios.get(
    `Organisation/CabinetType/Export/${operatorId}`,
    {
      responseType: "arraybuffer",
    },
  );
  return response;
};

export const supplierDownload = async (operatorId) => {
  const response = await axios.get(`Organisation/Supplier/Export/${operatorId}`, {
    responseType: "arraybuffer",
  });
  return response;
};

export const depotDownload = async (operatorId) => {
  const response = await axios.get(`Organisation/Depot/Export/${operatorId}`, {
    responseType: "arraybuffer",
  });
  return response;
};

export const noteAcceptorDownload = async (operatorId) => {
  const response = await axios.get(
    `Organisation/NoteAcceptor/Export/${operatorId}`,
    {
      responseType: "arraybuffer",
    },
  );
  return response;
};

export const gameTitleDownload = async (
  operatorId,
  isUpdated,
  manufacturerId,
) => {
  const response = await axios.get(
    `Organisation/GameTitle/Export/${operatorId},${isUpdated},${manufacturerId}`,
    {
      responseType: "arraybuffer",
    },
  );
  return response;
};

export const gameTitleLibraryDownload = async (
  operatorId,
  isUpdated,
  manufacturerId,
) => {
  const response = await axios.get(
    `Organisation/GameTitleLibrary/Export/${operatorId},${isUpdated},${manufacturerId}`,
    {
      responseType: "arraybuffer",
    },
  );
  return response;
};

export const newManufacturer = async (operatorId) => {
  const response = await axios.get(
    `Organisation/newmanufacturer/${operatorId}`,
  );
  return response.data;
};

export const newCabinetType = async (operatorId) => {
  const response = await axios.get(`Organisation/newcabinettype/${operatorId}`);
  return response.data;
};

export const newGameTitle = async (operatorId) => {
  const response = await axios.get(`Organisation/newgametitle/${operatorId}`);
  return response.data;
};
export const newDepot = async (operatorId) => {
  const response = await axios.get(`Organisation/newdepot/${operatorId}`);
  return response.data;
};

export const newNoteAcceptorModel = async (operatorId) => {
  const response = await axios.get(
    `Organisation/newnoteacceptormodel/${operatorId}`,
  );
  return response.data;
};

export const newSupplier = async (operatorId) => {
  const response = await axios.get(`Organisation/supplier/new/${operatorId}`);
  return response.data;
};

export const newAsset = async (operatorId) => {
  const response = await axios.get(`Asset/new/${operatorId}`);
  return response.data;
};

export const newCategory = async (operatorId) => {
  const response = await axios.get(`Organisation/newcategory/${operatorId}`);
  return response.data;
};

export const loadManufacturer = async (id) => {
  const response = await axios.get(`Organisation/manufacturer/${id}`);
  return response.data;
};

export const loadCategory = async (id) => {
  const response = await axios.get(`organisation/category/${id}`);
  return response.data;
};

export const loadDepot = async (id) => {
  const response = await axios.get(`organisation/depot/${id}`);
  return response.data;
};

export const loadCabinetType = async (id) => {
  const response = await axios.get(`organisation/cabinettype/${id}`);
  return response.data;
};

export const loadNoteAcceptorModel = async (id) => {
  const response = await axios.get(`Organisation/noteacceptormodel/${id}`);
  return response.data;
};

export const loadSupplier = async (id) => {
  const response = await axios.get(`Organisation/supplier/${id}`);
  return response.data;
};

export const loadGameTitle = async (id) => {
  const response = await axios.get(`Organisation/gametitle/${id}`);
  return response.data;
};

export const loadAsset = async (id) => {
  const response = await axios.get(`Asset/${id}`);
  return response.data;
};

export const updateManufacturer = async (
  id,
  OperatorId,
  details,
  callback = () => {},
) => {
  const payload = { id, OperatorId, details: prepareDetails(details) };
  const response = await axios.put(`/organisation/updatemanufacturer`, payload);
  callback();
  return response.data;
};

export const updateSupplier = async (
  id,
  OperatorId,
  details,
  callback = () => {},
) => {
  const payload = { id, OperatorId, details: prepareDetails(details) };
  const response = await axios.put(`/organisation/supplier/update`, payload);
  callback();
  return response.data;
};

export const updateDepot = async (
  id,
  OperatorId,
  details,
  callback = () => {},
) => {
  const payload = { id, OperatorId, details: prepareDetails(details) };
  const response = await axios.put(`/organisation/updatedepot`, payload);
  callback();
  return response.data;
};

export const updateAsset = async (
  Id,
  OperatorId,
  Complete,
  details,
  CopyAsset,
) => {
  const payload = {
    Id,
    OperatorId,
    Complete,
    details: prepareDetails(details),
    CopyAsset,
  };
  const response = await axios.put(`/asset/update`, payload);
  return response.data;
};

export const updateCategory = async (
  id,
  OperatorId,
  details,
  callback = () => {},
) => {
  const payload = { id, OperatorId, details: prepareDetails(details) };
  const response = await axios.put(`/organisation/updatecategory`, payload);
  callback();
  return response.data;
};

export const updateNoteAcceptorModel = async (
  id,
  OperatorId,
  details,
  callback = () => {},
) => {
  const payload = { id, OperatorId, details: prepareDetails(details) };
  const response = await axios.put(
    `/organisation/updatenoteacceptormodel`,
    payload,
  );
  callback();
  return response.data;
};

export const updateGameTitle = async (
  id,
  OperatorId,
  details,
  callback = () => {},
) => {
  const payload = { id, OperatorId, details: prepareDetails(details) };
  const response = await axios.put(`/organisation/updategametitle`, payload);
  callback();
  return response.data;
};

export const updateCabinetType = async (
  id,
  OperatorId,
  details,
  doUpdate,
  callback = () => {},
) => {
  const payload = {
    id,
    OperatorId,
    details: prepareDetails(details),
    doUpdate,
  };
  const response = await axios.put(`/organisation/updatecabinettype`, payload);
  callback();
  return response.data;
};
